import React from 'react';

import { connect } from 'react-redux';
import { IUser } from '../../slices/users/user';
import { RootState } from '../../slices/rootReducer';
import { selectors } from '../../slices/auth';

interface UserpilotSettings {
  userid?: string;
}

declare const window: {
  userpilotSettings?: UserpilotSettings;
} & Window;

interface IUserPilotProps {
  user: IUser | null;
}

class UserPilotBase extends React.PureComponent<IUserPilotProps> {
  componentDidUpdate() {
    const { user } = this.props;
    if (!user) {
      return;
    }

    const userPilotId: string | undefined = window.userpilotSettings?.userid;

    if (userpilot) {
      if (!userPilotId && user.id) {
        const fullName = user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : '';
        userpilot.identify(`${user.id}`, {
          name: user.fullName || fullName,
          email: user.email,
          created_at: user.createdAt,
          first_login: user.firstLogin,
          user_type: user.userType,
          company: {
            id: user.accountId,
            name: user.account?.name || '',
            account_type: user.account?.accessType
          }
        });
      }

      if (userPilotId) {
        userpilot.reload();
      }
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state: RootState): IUserPilotProps => {
  const user = selectors.getLoggedInUser(state);

  return {
    user
  };
};

export const UserPilot = connect(mapStateToProps, {})(UserPilotBase);
